export var EPIC_END = '@@redux-observable/EPIC_END';


//////////////////
// WEBPACK FOOTER
// ./~/redux-observable/lib/esm/EPIC_END.js
// module id = 329
// module chunks = 13